<template>
  <div :class="['social-post-preview-image', {'social-post-preview-image--loading': loading}]">
    <div v-if="loading" class="social-post-preview-image__loader">
      <shared-step-editor-loader :size="75" />
    </div>
    <img v-if="!error" :src="image" :alt="title" @load="onLoad" @error="onError" />
  </div>
</template>

<script>
import SharedStepEditorLoader from '../../../shared/SharedStepEditorLoader.vue';

export default {
  components: {
    SharedStepEditorLoader,
  },
  props: {
    image: String,
    title: String,
  },
  data: () => ({
    error: false,
    loading: false,
  }),
  methods: {
    onError() {
      this.error = true;
      this.loading = false;
      if (this.image?.length) $.notify('Wrong Image Source!', 'error');
    },
    onLoad() {
      this.error = false;
      this.loading = false;
    },
  },
  watch: {
    image(val) {
      if (!this.loading) {
        this.loading = true;
      }
      this.error = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.social-post-preview-image {
  background: $color-mercury;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &--loading {
    min-height: 300px;
  }
  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($white-color, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__src {
    width: 100%;
  }
}
</style>
